export default __webpack_public_path__ + "7c8642f2006a8bdaba0ff51f526a6a78.png";